import { useAuth } from "context/AuthContext";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAuthCheck = (bypassCheck = false) => {
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (bypassCheck) {
      return;
    }

    // Delay the check slightly
    const timer = setTimeout(() => {
      const token = localStorage.getItem("sessionToken");
      if (!token) {
        navigate("/connexion");
      } else if (token) {
        try {
          const decodedToken = jwtDecode(token);
          // Normalize old tokens: user_area (string) -> user_areas (array)
          if (!Array.isArray(decodedToken.user_areas)) {
            decodedToken.user_areas = decodedToken.user_area ? [decodedToken.user_area] : [];
          }
          const currentTime = Date.now() / 1000;
          if (decodedToken.exp < currentTime) {
            // Token expired
            localStorage.removeItem("sessionToken");
            setUser(null);
            navigate("/connexion");
          } else {
            setUser(decodedToken);
          }
        } catch (error) {
          // Invalid token
          localStorage.removeItem("sessionToken");
          setUser(null);
          navigate("/connexion");
        }
      } else {
        // No token found
        navigate("/connexion");
      }
    }, 500); // Delay of 500ms
    return () => clearTimeout(timer);
  }, [navigate, setUser, bypassCheck]);
};

export default useAuthCheck;
